<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as STAFF_TYPOLOGY_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'StaffTypologyCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: STAFF_TYPOLOGY_TYPES.GENERIC.organization.stafftypology.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...STAFF_TYPOLOGY_TYPES.GENERIC.organization.stafftypology.LIST.ACTIONS
    })
  }
}
</script>
